export interface CustomerOverviewProps {
    id: number;
    code: string;
    name: string;
    city: string;
    state_province: string;
    is_active: number;
  }
  export interface CustomerProps {
    id?: string;
    client: any;
    code: string;
    name: string;
    address_line_1: string;
    address_line_2?: string;
    address_line_3?: string;
    city: string;
    state_province: string;
    postal_code: string;
    contact_phone: string;
    contact_name?: string;
    country: any;
    country_code?: string;
    is_active: boolean;
    contact_email?: string;
  }
  export const customerDefaultvalues={
    id: "",
    client: {},
    customer: {}  ,
    code: "",
    name: "",
    address_line_1: "",
    address_line_2: "",
    address_line_3: "",
    city: "",
    state_province: "",
    postal_code: "",
    contact_phone: "",
    contact_name: "",
    country: "",
    is_active: true
  }
  export interface CustomerShipToProps {
    client: {
        code: string;
    };
    customer: {
        code: string;
    };
    id?: string;
    code: string;
    name: string;
    address_line_1: string;
    address_line_2?: string;
    address_line_3?: string;
    city: string;
    state_province: string;
    postal_code: string;
    contact_phone: string;
    contact_name?: string;
    country: any;
    is_active: boolean;
    contact_email?: string;
}
export interface CustomerShipToListProps {
  id?: number;
  customer_id?: number;
  code?: string;
  name?: string;
  address_line_1?: string | null;
  address_line_2?: string | null;
  address_line_3?: string | null;
  contact_phone?: string | null;
  city?: string;
  state_province?: string;
  postal_code?: string;
  country?: string;
  country_code?: string;
}
